<h3>{{ meeting.date | amFromUnix | amDateFormat:'DD/MM/YYYY' }} | {{ (meeting.user | resolveUser).email }}</h3>
<p *ngIf="meeting.locationTown && meeting.locationLga" class="mb-3 d-block">Location: {{ meeting.locationTown }}, {{ (meeting.locationLga | resolveLga).name }}</p>
<p *ngIf="meeting.notes" class="mb-3 d-block font-italic">Notes: {{ meeting.notes }}</p>
<mat-divider></mat-divider>
<br/>
<h1>Attendees</h1>
<mat-list class="odd-even-list">
  <mat-list-item>
    <div class="row">
      <h3 class="col-9 m-0">Property</h3>
      <h3 class="col-3 m-0 text-right">Attendees</h3>
    </div>
  </mat-list-item>
  <mat-list-item *ngFor="let prop of properties" class="mr-0 ml-0" (click)="selectAttendee(prop)">
    <div class="row">
      <span class="col-9 ellipsis clickable" style="line-height: 28px; font-size: medium">
        <span class="font-italic" [matTooltip]="prop.id">{{ prop.id | formatPropertyId }}:</span> {{ prop.name ? prop.name + ', ' : '' }}{{ prop.address }}
      </span>
      <span class="col-3 text-right">
            {{ propertyAttendees[prop.id] || 0 }}
      </span>
    </div>
  </mat-list-item>
</mat-list>
